namespace GeniuzPOS.QRreport {
    export enum pSequenFg {
        a1 = 0,
        a2 = 1,
        a3 = 2,
        a4 = 3,
        a5 = 4
    }
    Serenity.Decorators.registerEnumType(pSequenFg, 'GeniuzPOS.QRreport.pSequenFg');
}
